export enum AppLinkLocation {
  SIDEBAR = 'sidebar',
  USERMENU = 'usermenu',
}
export interface AppLink {
  viewName: string,
  title: string,
  classes?: string,
  location: AppLinkLocation,
  link?: string,
  regex?: RegExp,
  goToUrl?: string
}
